module.exports = __webpack_public_path__ + "img/final_off.d1552602.svg";